export default `
  mutation ($id: String!) {
    deleteLiveSearch(id: $id){ id }
  }
`;